define('shared/initializer/form/adapters/OnlineSalesLegacy',[
    '../constants',
    './Bootstrap2',
    './mixins/ProtocolGuarantee',
    './mixins/ConversionTrackable',
    './mixins/InputValuePersistable',
    './mixins/fields/AgeYoungerThanThirteen',
    './mixins/fields/Location',
    './mixins/fields/ConfirmPassword',
    './mixins/fields/DynamicSubscribe',
    './mixins/LPOnLoadDataDispatchable',
    './mixins/EmailRegistrationValidatable',
    './mixins/Submittable',
    './mixins/OSCommon',
    './mixins/CrossDomainSender',
    'shared/util/state',
    'shared/util/fields/common',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/lib/RSVP',
    './mixins/ClientIdTracking',
    'shared/lib/ctor'
],
function (
    constants,
    Bootstrap2Adapter,
    ProtocolGuarantee,
    ConversionTrackable,
    InputValuePersistable,
    AgeYoungerThanThirteenField,
    LocationField,
    ConfirmPasswordField,
    DynamicSubscribeField,
    LPOnLoadDataDispatchable,
    EmailRegistrationValidatable,
    Submittable,
    OSCommon,
    CrossDomainSender,
    state,
    fieldUtil,
    FormDataDispatcher,
    RSVP,
    ClientIdTracking,
    ctor
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply( null, arguments );

        me.mixin(
            EmailRegistrationValidatable,
            LPOnLoadDataDispatchable,
            ProtocolGuarantee,
            ConversionTrackable,
            InputValuePersistable,
            CrossDomainSender,
            AgeYoungerThanThirteenField,
            LocationField,
            ConfirmPasswordField,
            DynamicSubscribeField,
            Submittable,
            OSCommon,
            ClientIdTracking
        );

    }).inherit(Bootstrap2Adapter);

    return Ctor;
});

